import React from 'react';

import BottomMenu from 'src/features/home/BottomMenu';
import Info from 'src/features/home/Info';
import Schedule from 'src/features/home/Schedule';

export default function Home() {
  return (
    <div>
      <Info />
      <Schedule />
      <BottomMenu />
    </div>
  );
}
